import { Component, Input, OnInit } from '@angular/core';
import { GroupSelectorDTO } from 'src/AngularJS/Reusables/group-selector.models';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleSettingsView } from 'src/shared/models/module-manager/module-manager-settings.models';
import SlideoutSettingsManager from 'src/shared/models/slideout-settings-manager';

@Component({
    selector: 'cv-qm-evaluator-performance-settings',
    templateUrl: './qm-evaluator-performance-settings.component.html',
    styleUrls: ['./qm-evaluator-performance-settings.component.scss']
})
export class QmEvaluatorPerformanceSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    slideout = ModuleSettingsView.Slideout;
    modal = ModuleSettingsView.Modal;
    cxOne = ModuleSettingsView.CXOneModal;

    teamsSelected: any[];
    groupsSelected: any[];

    rangeSlider: any;
    appealedScaleValue: number;
    overturnsScaleValue: number;

    initialized = false;

    selectedGroupsDto: GroupSelectorDTO = null;
    settingsManager: SlideoutSettingsManager;

    // For additional filters
    selectedMetrics = [15130, 15128, 15173, 15172, 15171, 15129, 15132, 15131, 100654, 17584, 17585];

    constructor() { }

    async ngOnInit(): Promise<void> {
        this.moduleManager.slideoutSettingsManager.subscribe(manager => {
            this.settingsManager = manager;
        });
        this.moduleManager.addSetting({
            name: 'CompletedScale',
            required: true,
            onMissingValue: () => {
                this.rangeSlider = [60, 80];
            },
            getValue: () => this.rangeSlider,
            onSettingLoaded: value => {
                this.rangeSlider = value;
            },
            defaultValue: [60, 80],
        });

        this.moduleManager.addSetting({
            name: 'AppealedScale',
            required: true,
            onMissingValue: () => {
                this.appealedScaleValue = 10;
            },
            getValue: () => this.appealedScaleValue,
            onSettingLoaded: (value) => {
                this.appealedScaleValue = value;
            },
            defaultValue: 10,
        });

        this.moduleManager.customSettingsAdded = true;
        this.initialized = true;
    }
}
